export const CASES = {
    UPDATE_PRODUCTS: 'UPDATE_PRODUCTS',
    UPDATE_PRODUCTS_SEARCH_FORM: 'UPDATE_PRODUCTS_SEARCH_FORM',
    CLEAR_PRODUCTS: 'CLEAR_PRODUCTS',
};
